import io from 'socket.io-client';
import appUrl from './app/constants/appUrl';

const socket = io(`${appUrl.baseUrl}?userId=admin`, {
  transports: ['websocket'],
});

export default socket;